import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { SkapaTokens, SkapaColors, SkapaText, SkapaSSRIcon } from '@inter-ikea-guida/skapa';
const StyledFeatureList = styled.ul `
  padding: 0;
  margin: 0;
  margin-top: ${SkapaTokens.space50};
`;
const StyledFeature = styled.li `
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${SkapaTokens.space100};

  list-style: none;
  margin: 0;
  margin-bottom: ${SkapaTokens.space50};
`;
const StyledHeading = styled(SkapaText) `
  font-size: ${SkapaTokens.fontSize20};
  font-weight: 400;
  margin: 0;
  color: ${SkapaColors.colourTextAndIcon3};
`;
export const GuidaFeatureSection = ({ features, heading, headingTagName = 'span' }) => {
    if (!features.length) {
        return null;
    }
    return (_jsxs("div", { children: [heading && _jsx(StyledHeading, { tagName: headingTagName, children: heading }), _jsx(StyledFeatureList, { children: features?.map(b => (_jsxs(StyledFeature, { children: [_jsx(SkapaSSRIcon, { paths: b.icon }), _jsx(SkapaText, { children: b.text })] }, b.text))) })] }));
};
//# sourceMappingURL=GuidaFeatureSection.js.map